import { Reducer } from 'redux';
import { initialResponseState, IResponseState } from '../state';
import { GetReportsAction, GetReportsTypes } from './reports.type';
import { GlobalReducer } from '../app';

export const GetReportsReducer: Reducer<IResponseState, GetReportsAction> = (
	state = initialResponseState,
	action: GetReportsAction,
) => GlobalReducer(state, action, GetReportsTypes.GET_REPORTS.toString());
